<script setup>
import LayoutDefault from "../components/layout/LayoutDefault.vue";
import {  onMounted, ref } from "vue";
import * as Yup from "yup";
import {EmailMembershipCancelRequest, getAllStudiosCancellation} from "../mixins/api";
 const Schools = ref([]);
const TremsAndcCondition = ref(''); // To track the selected membership type
  const schema = Yup.object().shape({
        school_id: Yup.string().required("School ID is required"),
        firstname: Yup.string().required("First name is required"),
        lastname: Yup.string().required("Last name is required"),
        email: Yup.string().required("Email is required").email("Email is invalid"),
        telephone: Yup.string().required("Phone number is required"),
        cancellationReason: Yup.string().required("Message is required"),
        comments: Yup.string().required("Phone number is required"),
        membershipSource: Yup.string().required("Message is required"),
        requesttype: Yup.string().required("Message is required"),
    });
    const defaultMembershipCancellation = {
        school_id: 0,
        firstname: "",
        lastname: "",
        email: "",
        telephone: "",
        cancellationReason: "",
             comments: "",
        membershipSource: "",
        requesttype: "",
    };
    const MembershipCancellation = ref(defaultMembershipCancellation);

    const CancelSuccess = ref('');

    const CancelError = ref('');

    const contactFormSubmitting = ref(false);
    const Validateform = () => {
      try {
        schema.validateSync(MembershipCancellation.value, { abortEarly: false });
        return true;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          CancelError.value = err.errors[0] || "Please fill all the fields correctly.";
        } else {
          CancelError.value = "Validation failed. Please check your input.";
        }
        return false;
      }
    }
    const subject = "ILKB Customer Optin - Contact Form";
    const onCancelRequestSubmit = () => {
      if(contactFormSubmitting.value){return;}
        CancelError.value ="";
        CancelSuccess.value ="";
        if(MembershipCancellation.value.requesttype == '')
        {
            CancelError.value = "Please Confirm, do you want to cancel your membership or keep it active?";
            return;
        }
        if(MembershipCancellation.value.membershipSource == '')
        {
            CancelError.value = "Please confirm, did you purchase your membership online or in-studio?";
            return;
        }
        if(TremsAndcCondition.value===false)
        {
            CancelError.value = "Please check terms and condition checkbox";
            return;
        }
        if(Validateform() === false){
            CancelError.value = "Please fill all the fields";
            return;
        }
        
      console.log(MembershipCancellation.value);
        contactFormSubmitting.value = true
        EmailMembershipCancelRequest(MembershipCancellation.value, subject).then((response) => {
            contactFormSubmitting.value = false
            if (response) {
                console.log("SUCCESS");
                CancelSuccess.value = "Your request has been received and forwarded to your local studio. A team member will reach out to you soon."
                MembershipCancellation.value = {
                    school_id: 0,
                    firstname: "",
                    lastname: "",
                    email: "",
                    telephone: "",
                    cancellationReason: "",
                    comments: "",
                    membershipSource: "",
                    requesttype: "",
            } ;
          }else {
                console.log("ERROR");
                CancelError.value = "Please check and try again"
            }
        }).catch(()=>{contactFormSubmitting.value = false});
    };
        const getStudios = () => {
        getAllStudiosCancellation().then((response) => {
          Schools.value = response;
        });
    };
        onMounted(() => {
        getStudios();
        TremsAndcCondition.value=false;
       
    });
</script>
<template>
  <LayoutDefault>
    <div class="accessibility-statement">
      <div v-if="!CancelSuccess" class="module-container module-container-privacy_policy" id="privacy_policy">
        <div class="container">
          <div class="row">
            <section class="section-container col-100">
              <div class="element-contaier">
                <h2 class="element-text text-align-center font-size-65" style="margin-top: 50px;">Membership Cancellations</h2>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="module-container module-container-divider" style="padding: 0px;">
        <div class="container-fluid">
          <div class="row"><!--v-if--><!--v-if-->
            <div class="torn-paper-divider-3"></div><!--v-if-->
          </div>
        </div>
      </div>
      <div class="module-container text-color-default module-container-privacy_policy_details"
        id="privacy_policy_details" style="background-color: rgb(251, 251, 252); color: rgb(0, 0, 0);">
        <div class="container">
          <div class="row">
            <section class="section-container col-100">
              <div class="element-contaier">
                       <div class="row">
                <template v-if="CancelSuccess">
                    <div class="col-100">
                       <h3 style="margin-top: 30px;">{{CancelSuccess}}</h3> 
                    </div>
                </template>
                <template v-else-if="CancelError">
                    <div class="col-100">
                       <div class="alert alert-danger">{{CancelError}}</div> 
                    </div>
                </template>
            </div>
                <div  v-if="!CancelSuccess" class="rawHtml element-text font-size-16" role="heading" style="font-family: dm_sansregular; margin-top: 50px; margin-bottom: 50px;">
                  <h4>Modify Your Membership with I LOVE KICKBOXING</h4>
                  <p>
                   We hate to see you hang up your gloves, but we understand that sometimes life throws unexpected punches. Before you modify your membership, we want to make sure you know the options available to keep you feeling empowered and more confident!
                  <BR/>
                  All of the following options will help you maintain your membership with I LOVE KICKBOXING:
                  </p>
                  <ul>
                    <li>Not ready to commit long-term? No worries! Ask your local studio about fun workout Challenges or upcoming special events.</li>
                    <li>Need to take a break between classes? Some of our locations offer an option to pause your monthly membership for a small amount in place of your monthly billing to maintain your rate so you’re able to kick it with us when you’re ready!</li>
                    <li>Unsure if you’re able to train as often as you’d like? We have plenty of membership options to choose from and can easily adjust your membership to better match your schedule to ensure you’re getting the most out of your I LOVE KICKBOXING experience, no matter how often you train!</li>
                    <li>Want more flexibility? Ask your local studio about prepaid workout packs that don’t require a monthly commitment and offer flexible use at your own pace.</li>
                  </ul>
                  <ul v-if="!CancelSuccess">
                    <p style="margin-left: -40px;"> Did you want to try one of the options above and keep your membership active with I LOVE KICKBOXING?*</p>
                 
                        <input type="radio" id="requesttype" name="requesttype" 
                           value="Keep"  v-model="MembershipCancellation.requesttype" >
                              Yes, I’d like to keep my membership active and talk through other options.
                        <br/>
                        <br/>
                          <input type="radio" id="requesttype" name="requesttype"
                          value="Cancel"  v-model="MembershipCancellation.requesttype" > No, I’d still like to proceed with cancelling my membership.. 
                               <br/>
                                    <br/>
                  </ul>
                  <div :class="MembershipCancellation.requesttype !='' ? 'form-group showdiv' : 'form-group hidediv'" id="Membershipsource">
                    <ul>
                      <p style="margin-left: -36px;">
                          We are sad to hear you want to cancel your membership, we just need a few things to get your cancellation request submitted!
                      </p>
                
                        <input type="radio" id="purchasedOnline" name="purchasedOnline" value="Online" v-model="MembershipCancellation.membershipSource">
                        Yes, I purchased my I LOVE KICKBOXING Membership online at <a href="https://ilovekickboxing.com" target="_blank" rel="noopener noreferrer">ilovekickboxing.com</a>.
                        <br/>
                        <br/>
                        <input type="radio" id="purchasedInStudio" name="purchasedOnline" value="Local studio"  v-model="MembershipCancellation.membershipSource">
                        No, I purchased my I LOVE KICKBOXING Membership in a local studio.
                        <br />
                        <br />
                        </ul>
                    <div class="form-group cancellation-form-grid">
                      <div class="form-row">
                        <div class="form-col">
                          <label for="firstname">First Name<span style="color:red">*</span></label>
                          <input type="text" id="firstname" name="firstname" placeholder="First Name" required  v-model="MembershipCancellation.firstname">
                        </div>
                        <div class="form-col">
                          <label for="lastname">Last Name<span style="color:red">*</span></label>
                          <input type="text" id="lastname" name="lastname" placeholder="Last Name" required  v-model="MembershipCancellation.lastname">
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-col">
                          <label for="phonenumber">Phone Number<span style="color:red">*</span></label>
                          <input type="text" id="phonenumber" name="phonenumber" placeholder="Phone Number" required v-model="MembershipCancellation.telephone">
                        </div>
                        <div class="form-col">
                          <label for="email">Email<span style="color:red">*</span></label>
                          <input type="email" id="email" name="email" placeholder="Email" required  v-model="MembershipCancellation.email">
                          <small>Email address associated with your I LOVE KICKBOXING membership account.</small>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-col">
                          <label for="homeStudio">Home Studio<span style="color:red">*</span></label>
                          <select id="homeStudio" name="homeStudio" required  v-model="MembershipCancellation.school_id">
                            <option value="" disabled selected>Select your home studio</option>
                             <option v-for="item in Schools" :key="item.ID" :value="item.ID">
                             {{ item.Name }} - {{ item.City }}
                            </option>
                    
                            <!-- Add more studios as needed -->
                          </select>
                        </div>
                        <div class="form-col">
                          <label for="cancellationReason">Cancellation Reason<span style="color:red">*</span></label>
                          <select id="cancellationReason" name="cancellationReason" required  v-model="MembershipCancellation.cancellationReason">
                            <option value="" disabled selected>Select a reason</option>
                            <option value="No Time to Attend">No Time to Attend</option>
                            <option value="Unsatisfied with Facility">Unsatisfied with Facility</option>
                            <option value="Downgrade/Upgrade">Downgrade/Upgrade</option>
                            <option value="Seasonal Resident">Seasonal Resident</option>
                            <option value="Change Fitness Routine">Change Fitness Routine</option>
                            <option value="Medical">Medical</option>
                            <option value="Relocation">Relocation</option>
                            <option value="Financial">Financial</option>
                            <option value="Optum/ASH/ClassPass/WellHub">Optum/ASH/ClassPass/WellHub</option>
                            <option value="Prefer Not to Say">Prefer Not to Say</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-col-full">
                          <label for="comments">Comments</label>
                          <textarea id="comments" name="comments" rows="4" placeholder="Your comments here..." style="width:100%"  v-model="MembershipCancellation.comments"></textarea>
                        </div>
                      </div>
                    </div>
                    <br/>
                  <h3>Terms & Conditions*</h3>
                  <p>
                    
                    <input type="checkbox" id="TremsAndcCondition" name="TremsAndcCondition" value="TremsAndcCondition" v-model="TremsAndcCondition"/>
                  I LOVE KICKBOXING offers a 30-day cancellation policy, unless otherwise stated in your Membership Agreement. To process your cancellation request, your account status must be active and in good standing. In the event your account is frozen, the account must be reactivated before the membership cancellation request can be processed. Any membership payment set to occur within 30-days after receipt of your cancellation request will occur as scheduled. You will have 30 days from the date of your last payment to utilize any previously unused sessions. Any remaining sessions or promotional rates will be forfeited.</p>
                  <p>Please contact your home studio for any questions related to billing and refunds.</p>
                  <p>Please be aware your home studio will need to contact you to verify your membership & cancellation request.</p>
                 <Button type="submit" v-if="!contactFormSubmitting" text="Submit" @click="onCancelRequestSubmit"  style="height:50px;" class="col-100">Submit</Button>
                  <button type="button" v-else class="btn btn-primary col-100" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting... </button> 
                </div>
              </div>
              
              </div>  
            </section>
          </div>
        </div>
      </div>
    </div>
  </LayoutDefault>
</template>

<style scoped>
/* Component-specific styles go here */
.Cancellations {
  /* Add styles as needed */
}
.hidediv{
  display: none;
}
.showdiv{
  display: block;
}
  .cancellation-form-grid {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1.5rem;
  }
  .form-row {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
  }
  .form-col {
    flex: 1 1 220px;
    min-width: 180px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .form-col-full {
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  label {
    font-weight: 600;
    margin-bottom: 0.25rem;
  }
  input, select, textarea {
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
  }
  input:required, select:required, textarea:required {
    background-color: #fff8f8;
  }
  small {
    color: #666;
    font-size: 0.85em;
  }
</style>
